import { mockApiCall } from '../../../utils/mock'
import { AsyncList as AsyncListComponent } from '../../AsyncList'

import { PAGES } from './AsyncList.mocks'
import { ListItem } from './ListItem'

function AsyncList() {
  function getData(page) {
    return mockApiCall({ value: PAGES[page] })
  }

  return (
    <AsyncListComponent ListItem={ListItem} getData={getData} maxHeight={130} />
  )
}

export default AsyncList
